const icons = require.context('./', false, /\.svg$/);
icons.keys().forEach(icons);
